import { useState, useEffect, useContext } from 'react';
import { getStatesURL } from '../utils/ConstantsURL';
import { AuthContext } from '../context/AuthContext';

export const useGetStates = () => {
  const [states, setStates] = useState([]);
  const [isLoadingStates, setIsLoadingStates] = useState(true);
  const [errorStates, setErrorStates] = useState(null);
  const { token } = useContext(AuthContext);

  useEffect(() => {
    const fetchStates = async () => {
      setIsLoadingStates(true);
      setErrorStates(null);
      
      try {
        const response = await fetch(getStatesURL(), {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();

        const transformedData = data.map(state => ({
          id: state.FESCLAVE,
          name: state.FESDESCRIPCION
        }));

        setStates(transformedData);
      } catch (error) {
        setErrorStates(error.message);
      } finally {
        setIsLoadingStates(false);
      }
    };

    if (token) {
      fetchStates();
    }
  }, [token]);

  return { states, isLoadingStates, errorStates };
};
